import tier1 from './tier1'
import tier2 from './tier2'
import tier3 from './tier3'
import tier4 from './tier4'
import tier5 from './tier5'
import tier6 from './tier6'
import tier7 from './tier7'

const shadow = {
	spec: 'shadow',
	icon: 'spell_shadow_shadowwordpain',
	talents: [tier1, tier2, tier3, tier4, tier5, tier6, tier7],
}

export default shadow
